module.exports = __webpack_public_path__ + "img/video.11e988e1.png";